document.addEventListener("DOMContentLoaded", function () {
  // ------------------------------------------------
  // メディアクエリ監視
  // ------------------------------------------------
  const watchBreakpoint = window.matchMedia("(max-width: 768px)");

  // ------------------------------------------------
  // ドロワーメニュー制御
  // ------------------------------------------------
  // 各要素の取得
  const navOpenBtn = document.getElementById("js-navOpen");
  const navCloseBtn = document.getElementById("js-navClose");
  const drawerMenu = document.getElementById("js-drawerMenu");
  const body = document.body;

  // メニューを開く関数
  function openMenu() {
    // ドロワーメニューと開くボタンに「js-open」クラスを追加
    // drawerMenu.classList.add("js-open");
    // navOpenBtn.classList.add("js-open");
    drawerMenu.classList.add("js-open");

    // aria-expanded 属性を true に変更（メニューが開いた状態）
    navOpenBtn.setAttribute("aria-expanded", "true");

    // スクロールロック（背景スクロールを防止）
    body.style.height = "100%";
    body.style.overflow = "hidden";
  }

  // メニューを閉じる関数
  function closeMenu() {
    // ドロワーメニューと開くボタンから「js-open」クラスを削除
    // drawerMenu.classList.remove("js-open");
    // navOpenBtn.classList.remove("js-open");
    drawerMenu.classList.remove("js-open");

    // aria-expanded 属性を false に変更（メニューが閉じた状態）
    navOpenBtn.setAttribute("aria-expanded", "false");

    // スクロールロック解除
    body.style.height = "";
    body.style.overflow = "";
  }

  // イベントリスナーの設定
  if (navOpenBtn) {
    navOpenBtn.addEventListener("click", openMenu);
  }
  if (navCloseBtn) {
    navCloseBtn.addEventListener("click", closeMenu);
  }

  // メニュークリックでメニューを閉じる
  const drawerLinks = document.querySelectorAll(".custom-header-drawer__link");
  drawerLinks.forEach((link) => {
    link.addEventListener("click", closeMenu);
  });

  const drawerBtns = document.querySelectorAll(".custom-header-drawer__btn");
  drawerBtns.forEach((btn) => {
    btn.addEventListener("click", closeMenu);
  });

  document.addEventListener("click", function (event) {
    // メニューが開いている場合のみ処理する
    if (drawerMenu.classList.contains("js-open")) {
      // クリックされた要素が drawerMenu または navOpenBtn の中に含まれている場合は何もしない
      if (
        !drawerMenu.contains(event.target) &&
        !navOpenBtn.contains(event.target)
      ) {
        closeMenu();
      }
    }
  });

  // ------------------------------------------------
  // 企業理念 スライダー
  // ------------------------------------------------
  var philosophyGalleryEl = document.querySelector(".top-philosophy__gallery");
  if (philosophyGalleryEl) {
    const slideCount = philosophyGalleryEl.querySelectorAll('.swiper-slide').length;
    if (slideCount > 1) {
      var philosophyGallery = new Swiper(".top-philosophy__gallery", {
        loop: true,
        slidesPerView: 1.3,
        spaceBetween: 0,
        speed: 10000,
        allowTouchMove: false, // 手動スワイプ禁止
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        breakpoints: {
          768: {
            slidesPerView: 2.5,
          },
        },
      });
    }
  }

  // ------------------------------------------------
  // フロースライド
  // ------------------------------------------------
  var flowSliderEl = document.querySelector(".top-flow__slider");
  if (flowSliderEl) {
    const topFlowSlider = new Swiper(".top-flow__slider", {
      slidesPerView: 'auto',
      spaceBetween: 16,
      navigation: {
        nextEl: ".top-flow__button-next",
        prevEl: ".top-flow__button-prev",
      },
      pagination: {
        el: ".top-flow__pagination",
        type: "progressbar",
      },
    });
  }

  // ------------------------------------------------
  // よくあるご質問
  // ------------------------------------------------
  const initializeAccordion = (details) => {
    const summary = details.querySelector("summary");
    const panel = details.querySelector("summary + *");

    if (!(details && summary && panel)) return; // 必要要素が揃ってない場合は処理をやめる
    let isTransitioning = false; // 連打防止フラグ

    const onOpen = () => {
      if (details.open || isTransitioning) {
        return;
      }
      isTransitioning = true;
      panel.style.gridTemplateRows = "0fr";
      details.setAttribute("open", "");
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          panel.style.gridTemplateRows = "1fr";
        });
      });
      panel.addEventListener(
        "transitionend",
        () => {
          isTransitioning = false;
        },
        { once: true }
      );
    };

    const onClose = () => {
      if (!details.open || isTransitioning) {
        return;
      }
      isTransitioning = true;
      panel.style.gridTemplateRows = "0fr";
      panel.addEventListener(
        "transitionend",
        () => {
          details.removeAttribute("open");
          panel.style.gridTemplateRows = "";
          isTransitioning = false;
        },
        { once: true }
      );
    };

    summary.addEventListener("click", (event) => {
      event.preventDefault();

      if (details.open) {
        onClose();
      } else {
        onOpen();
      }
    });
  };

  // .top-faq__item は全て <details> なので、全てに対応
  const accordions = document.querySelectorAll(".top-faq__item");
  accordions.forEach((details) => {
    initializeAccordion(details);
  });

  // .top-works__list-details は全て <details> なので、全てに対応
  const worksAccordions = document.querySelectorAll(".top-works__list-details");
  worksAccordions.forEach((details) => {
    initializeAccordion(details);
  });

  // ------------------------------------------------
  // スクロールアニメーション
  // ------------------------------------------------
  const animObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          animObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );

  // 単一要素を登録（セレクタ + 任意の遅延）
  function observeAnim(selector, delay = 0) {
    const el = document.querySelector(selector);
    if (!el) return;
    el.classList.add("anim-fade-up");
    el.style.setProperty("--anim-delay", `${delay}s`);
    animObserver.observe(el);
  }

  // 複数要素をずらし表示で登録
  function observeAnimAll(selector, baseDelay = 0, step = 0.1) {
    document.querySelectorAll(selector).forEach((el, i) => {
      el.classList.add("anim-fade-up");
      el.style.setProperty("--anim-delay", `${baseDelay + i * step}s`);
      animObserver.observe(el);
    });
  }

  // 企業理念セクション
  observeAnim(".top-philosophy .custom-section__headline");
  observeAnim(".top-philosophy__content", 0.1);

  // 事業内容セクション
  observeAnim(".top-business .custom-section__headline");
  observeAnim(".top-business__description", 0.1);
  observeAnimAll(".top-business__item", 0, 0.12);

  // 実績セクション
  observeAnim(".top-works .custom-section__headline");
  observeAnim(".top-works__main", 0.1);
  observeAnimAll(".top-works__item", 0.05, 0.12);

  // ご挨拶セクション
  observeAnim(".top-greeting .custom-section__headline");
  observeAnim(".top-greeting__inner", 0.1);

  // フローセクション
  observeAnim(".top-flow .custom-section__headline");

  // FAQセクション
  observeAnim(".top-faq .custom-section__headline");
  observeAnimAll(".top-faq__item", 0, 0.07);

  // 会社概要セクション
  observeAnim(".top-company .custom-section__headline");
  observeAnim(".top-company__content", 0.1);

  // お問い合わせセクション
  observeAnim(".top-contact .custom-section__headline");
  observeAnim(".top-contact__lead", 0.1);
});
